import ErrorLogEntity from '../entities/error-log/ErrorLog.Entity';
import { apiPost } from '../support/helpers/ApiConnection.Helper';

export default function sendErrorLog(errorDataModel: ErrorLogEntity,abortSignal: AbortSignal): Promise<ErrorLogEntity> {
    return apiPost<ErrorLogEntity>('/error-logs', errorDataModel, abortSignal, false, false);
}
